import { getIconBaseUrl } from "../../utils/assets";
export const linksBlockDefaultDataOne = {
    title: "About Haven",
    titleLink: "/about-us",
    links: [
        {
            linkUrl: "/about-us/awards",
            title: "Awards",
        },
        {
            linkUrl: "/about-us/partner-with-us",
            title: "Partner with us",
        },
        {
            linkUrl: "https://jobs.haven.com",
            title: "Careers at Haven",
            openInNewTab: true,
        },
        {
            linkUrl: "/about-us/modern-slavery",
            title: "Modern Slavery Act",
        },
        {
            linkUrl: "/about-us/sustainability",
            title: "Caring for the environment",
        },
        {
            linkUrl: "/about-us/announcement",
            title: "Government announcements",
        },
        {
            linkUrl: "https://news.haven.com",
            title: "Media Enquiries",
        },
    ],
};
export const linksBlockDefaultDataTwo = {
    title: "Types of holiday",
    titleLink: "/holidays",
    links: [
        {
            linkUrl: "/touring-camping",
            title: "Camping holidays & touring",
        },
        {
            linkUrl: "/holidays/uk-breaks/weekend",
            title: "Weekend and short breaks",
        },
        {
            linkUrl: "/holidays/uk-breaks",
            title: "Family UK breaks",
        },
        {
            linkUrl: "/holidays/family/baby-toddler",
            title: "Baby and toddler friendly holidays",
        },
        {
            linkUrl: "/holidays/summer",
            title: "Summer holidays",
        },
        {
            linkUrl: "/holidays/half-term",
            title: "Half term holidays",
        },
        {
            linkUrl: "/holiday-inspiration",
            title: "Holiday Inspiration",
        },
        {
            linkUrl: "/beaches",
            title: "Beaches",
        },
        {
            linkUrl: "/things-to-do",
            title: "Things to do",
        },
        {
            linkUrl: "/holidays/groups",
            title: "Groups",
        },
        {
            linkUrl: "/holidays/self-catering",
            title: "Self catering",
        },
    ],
};
export const linksBlockDefaultDataThree = {
    title: "Helpful links",
    links: [
        {
            linkUrl: "/payments",
            title: "Payments",
        },
        {
            linkUrl: "https://support.haven.com",
            title: "Help & FAQs",
        },
        {
            linkUrl: "/support/opening-hours",
            title: "Contact us",
        },
        {
            title: "Site Map",
            linkUrl: "/support/sitemap",
        },
    ],
};
export const bottomMenuDefaultData = {
    title: "Policies",
    links: [
        {
            title: "Accessibility",
            linkUrl: "/support/accessibility",
        },
        {
            title: "Manage Consent",
            linkUrl: "#",
            className: "ot-sdk-show-settings",
            id: "fides-modal-link",
        },
        {
            title: "Caravan Ownership Policies",
            linkUrl: "/support/caravan-ownership-policies",
        },
        {
            title: "Cookies Policy",
            linkUrl: "/support/cookies-policy",
        },
        {
            title: "Privacy policy",
            linkUrl: "/support/privacy-policy",
        },
        {
            title: "Terms and conditions",
            linkUrl: "/support/terms-and-conditions",
        },
    ],
};
export const contactDefaultData = {
    title: "Get in touch, we're here to help",
    contacts: [
        {
            title: `Holiday enquiries | Mon-Sun`,
            phoneNumber: "0333 202 5250",
            linkUrl: "/support/opening-hours",
            linkTitle: "Opening hours",
        },
        {
            title: "Ownership enquiries",
            phoneNumber: "0333 202 1460",
            linkUrl: "/support/opening-hours",
            linkTitle: "Opening hours",
        },
    ],
};
export const socialMenuDefaultData = {
    links: [
        {
            icon: getIconBaseUrl("facebook-white.svg"),
            title: "Haven on Facebook",
            linkUrl: "https://www.facebook.com/havenofficial",
        },
        {
            icon: getIconBaseUrl("tik-tok.svg"),
            title: "Haven on TikTok",
            linkUrl: "https://www.tiktok.com/@havenofficial",
        },
        {
            icon: getIconBaseUrl("instagram-white.svg"),
            title: "Haven on Instagram",
            linkUrl: "https://www.instagram.com/havenofficial",
        },
        {
            icon: getIconBaseUrl("youtube-white.svg"),
            title: "Haven on Youtube",
            linkUrl: "https://www.youtube.com/user/havenholidays",
        },
    ],
};
